<template>
  <div class="topHeader" :class="{hideLeft: hideLeft}">
    <template v-if="selectMore">
      <mt-header :title="title"
                 fixed
                 :style="{backgroundColor:bgcolor}">
        <template v-if="selectMoreing">
                <span slot="left"
                      @click="operate"
                      class="leftMore">{{operateText}}</span>
          <span slot="right"
                @click="cancleSelectMore"
                class="rightMore">{{$t('cancel')}}</span>
        </template>
        <template v-else>
          <i class="mintui mintui-back"
             v-if='backToClose'
             @click="changeFlag"
             slot="left"></i>
          <i class="mintui mintui-back"
             v-else
             @click="geturl()"
             slot="left"></i>
          <span slot="right"
                @click="more"
                class="rightMore">{{$t('multi_select')}}</span>
        </template>
      </mt-header>
    </template>
    <template v-else-if='simpleTitle'>
      <mt-header :title="title"
                 fixed
                 :style="{backgroundColor:bgcolor}">
      </mt-header>
    </template>
    <template v-else-if='noMore'>
      <mt-header :title="title"
                 fixed
                 :style="{backgroundColor:bgcolor}">
        <i class="mintui mintui-back"
           @click="geturl()"
           slot="left"></i>
      </mt-header>
    </template>
    <template v-else>
      <mt-header :title="title"
                 fixed
                 :style="{backgroundColor:bgcolor}">
        <i class="mintui mintui-back"
           @click="geturl()"
           slot="left"></i>
        <mt-button icon="more"
                   @click="sheetVisible=true"
                   slot="right"></mt-button>
      </mt-header>
      <actionsheet :actions="actions"
                   v-model="sheetVisible"
                   :cancelText="$t('cancel')"></actionsheet>
    </template>
  </div>
</template>

<script>
  import {
    Actionsheet
  } from "mint-ui";
  import {
    shareApp
  } from "../../assets/js/share.js";

  export default {
    props: {
      selectMore: {
        default: false
      },
      hideLeft: {
        default: false
      },
      backToClose: {
        default: false
      },
      back: {
        default: true
      },
      title: {
        default: ""
      },
      url: {
        default: ""
      },
      simpleTitle: {
        default: false
      },
      noMore: {
        default: false
      },
      selfMethod: {
        default: ""
      },
      replace: {
        default: "true"
      },
      bgcolor: {
        default: "#393C41"
      },
      operateTextConfirm: {
        default: 'operate'
      }
    },
    data() {
      return {
        sheetVisible: false,
        actions: [],
        selectMoreing: false //是否是多选状态
      };
    },

    mounted() {
      // 钉钉里不要换这个标题了
      if (!dd){
        document.title = this.title;
      }
      if (this.$isMihotel) {
        this.actions.push({
          name: this.$t("share"),
          method: () => {
            shareApp();
          }
        });
      }
      this.actions.push({
        name: this.$t("refresh"),
        method: this.refresh
      });
      this.actions.push({
        name: this.$t("home"),
        method: this.gohome
      });
    },
    methods: {
      changeFlag(){
        this.$emit('changeFlag')
      },
      cancleSelectMore() {
        //关闭多选
        this.selectMoreing = false;
        this.$emit("cancleSelectMore");
      },
      operate() {
        //多选完成
        this.$emit("operateMultSelected");
      },
      more() {
        //进行多选
        this.selectMoreing = true;
        this.$emit("goSelect");
      },
      geturl() {
        if (this.selfMethod == "") {
          let backUrl = ''
          if (this.url){
            backUrl = this.url
          } else {
            backUrl = this.$getIsOpera() ? '/opera/' : "/"
          }
          return this.$router.push(this.$route.query.redirect || backUrl);
        } else {
          this.$emit("leftClick");
        }
      },
      gohome() {
        let url = this.$getIsOpera() ? '/opera/' : "/"
        this.$router.push(url);
      },
      refresh() {
        location.reload();
      }
    },
    computed: {
      operateText() {
        if(this.operateTextConfirm == 'determine'){
          return this.$t('determine')
        } else {
          return this.$t('operate')
        }
      }
    },
    components: {
      actionsheet: Actionsheet
    }
  };
</script>

<style lang="less"
       scoped>
  .topHeader {
    height: 1.04rem;

    .mint-header {
      color: #fff;
      font-size: 16px;
      top: -1px;
      padding: 0;
      z-index: 100;

      .leftMore,
      .rightMore {
        padding: 0 0.2rem;
        font-size: 14px;
      }
    }

    .mintui-back {
      line-height: 0.853333rem;
      padding: 0.2rem;
    }

    &.hideLeft{
      .mintui-back {
        display: none;
      }
    }

    .mint-button {
      padding: 0 0.2rem;
    }
  }
</style>



// WEBPACK FOOTER //
// topNav.vue?011784b6